import React from 'react';
import { useRouteMatch } from 'react-router';

import CreateEmailSendingConfig from 'pages/Private/EmailSending/CreateEmailSendingConfig';
import ListEmailSendingConfigs from 'pages/Private/EmailSending/ListEmailSendingConfigs';

import { Route } from '../Route';

export const EmailSendingRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${path}/list`} component={ListEmailSendingConfigs} />
      <Route isPrivate path={`${path}/create`} component={CreateEmailSendingConfig} />
    </>
  );
};
